import { TemplateButton } from "./TemplateButton";

export default TemplateButton;
